import React from "react"
import { SaleStatement } from "../../../models/contract/SaleStatement"
import { Divider } from "@mui/material"
import { t } from "i18next"
import { colorDark, colorGrey } from "../../../rsc/colors/colors"

type Props = {
    statement?: SaleStatement
}
export const StatementComponent: React.FC<Props> = ({ statement }) => {
    // const lineItems = statement?.line_items?.map((li, index) => {
    //     // const displayTitle = li.isETaxLineItem() ? "none" : "block"
    //     return (
    //         <div key={index} className="pempem-flex-row gap10">
    //             <div className="pempem-flex-row" style={{ width: 100 }}>
    //                 <span style={{ marginRight: "5px", fontWeight: "700", color: "black", fontSize: "18px" }}>{li.price_per_unit}</span>
    //                 <span style={{ marginRight: "10px", fontWeight: "700", color: "black", fontSize: "11px" }}>Rp/KG</span>

    //             </div>
    //             <span style={{ marginRight: "10px", fontWeight: "700", color: "black", fontSize: "11px" }}>x</span>
    //             <div className="pempem-flex-row-center" style={{ width: 100 }}>
    //                 <span style={{ marginRight: "5px", fontWeight: "700", color: "black", fontSize: "18px" }}>{li.quantity}</span>
    //                 <span style={{ marginRight: "10px", fontWeight: "700", color: "black", fontSize: "11px" }}>KG</span>
    //             </div>
    //             <span>=</span>
    //             <div className="pempem-flex-row" style={{ width: 100 }}>
    //                 <span style={{ marginRight: "5px", fontWeight: "700", color: li.total > 0 ? "black" : "red", fontSize: "18px", flex: 1, alignSelf: "end" }}>{li.total.IndoFormat()}</span>
    //                 <span style={{ marginRight: "0px", fontWeight: "700", color: li.total > 0 ? "black" : "red", fontSize: "11px", alignSelf: "end" }}>Rp</span>
    //             </div>
    //         </div>
    //     )
    // })

    const lineItems = statement?.line_items?.map((li, index) => {
        // const displayTitle = li.isETaxLineItem() ? "none" : "block"
        return (
            <tr key={index}>
                <td width={'auto'} className="pempem-flex-row-end" style={{margin:'5px 0'}}>
                    <span style={{ marginRight: "5px", fontWeight: "700", fontSize: "18px" }}>{li.price_per_unit}</span>
                    <span style={{ marginRight: "5px", fontWeight: "700", fontSize: "11px" }}>Rp/KG</span>
                </td>
                <td style={{ marginRight: "10px", fontWeight: "700" }}>x</td>
                <td width={'auto'} className="pempem-flex-row-end">
                    <span style={{ marginRight: "5px", marginLeft: 5,fontWeight: "700", fontSize: "18px" }}>{li.quantity}</span>
                    <span style={{ marginRight: "10px", fontWeight: "700", fontSize: "11px" }}>KG</span>
                </td>
                <td>=</td>
                <td width={'auto'} className="pempem-flex-row-end gap5" style={{marginLeft: 5}}>
                    <span style={{ fontWeight: "700", color: li.total > 0 ? colorDark() : "red", fontSize: "18px", alignSelf: "end" }}>{li.total.IndoFormat()}</span>
                    <span style={{ fontWeight: "700", color: li.total > 0 ? colorDark() : "red", fontSize: "11px", alignSelf: "end" }}>Rp</span>
                </td>
            </tr>
        )
    })

    return <div style={{ color: colorDark()}}>
        <div className="pempem-flex-col gap5" style={{ width: "fit-content", alignItems: 'start' }}>
            <table style={{borderBottom: `1px solid ${colorGrey()}`}}>
                <tbody>
                    {lineItems}
                </tbody>
            </table>
            <div style={{ display: "flex", width:'100%', alignItems:'end'}}>
                <span style={{ marginRight: "5px", fontWeight: "700", fontSize: "26px", flex: 1 }}>{statement?.getPreTaxTotal() ? t('total_plus_tax') : t('total')}</span>
                <span className="font-24" style={{ marginRight: "0px", fontWeight: "700" }}>{statement?.getPreTaxTotal() ?? statement?.getTotal().IndoFormat()}</span>
                <span style={{ marginRight: "0px", fontWeight: "700", fontSize: "11px" }}>Rp</span>
            </div>
        </div>
        {
            statement?.getPricePerUnit() &&
            <div>
                {/* {
                        contract?.getSaleStatement()?.getPreTaxTotal() &&
                        <div style={{ marginTop: "20px", display: "flex" }}>
                            <span style={{ marginRight: "5px", fontWeight: "700", color: "black", fontSize: "18px", flex: 1 }}>{t('total')}</span>
                            <span style={{ marginRight: "5px", fontWeight: "700", color: "black", fontSize: "20px" }}>{contract.getSaleStatement()?.getPreTaxTotal()?.IndoFormat()}</span>
                            <span style={{ marginRight: "0px", fontWeight: "700", color: "black", fontSize: "11px" }}>Rp</span>
                        </div>
                    }
                    {
                        contract?.getSaleStatement()?.getTaxTotal() &&
                        <div style={{ marginTop: "20px", display: "flex" }}>
                            <span style={{ marginRight: "5px", fontWeight: "700", color: "black", fontSize: "18px", flex: 1 }}>{t('tax_total')}</span>
                            <span style={{ marginRight: "5px", fontWeight: "700", color: "black", fontSize: "20px" }}>{contract.getSaleStatement()?.getTaxTotal()?.IndoFormat()}</span>
                            <span style={{ marginRight: "0px", fontWeight: "700", color: "black", fontSize: "11px" }}>Rp</span>
                        </div>
                    } */}

            </div>
        }
    </div >
}